export default __webpack_public_path__ + "static/media/Times Higher Education.7dfcbb84.png";